import {
  TRIGGER_CONFIG_APP_PASSWORD_MODAL,
  TRIGGER_FEEDBACK_MODAL,
} from "../../constants/action.constants";

const initialState = {
  showFeedbackModal: false,
  showConfigAppPasswordModal: false,
};

//Reducer to set if modals need to be shown or not.
const franchiseListReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRIGGER_FEEDBACK_MODAL:
      return { ...state, showFeedbackModal: !state.showFeedbackModal };
    case TRIGGER_CONFIG_APP_PASSWORD_MODAL:
      return {
        ...state,
        showConfigAppPasswordModal: !state.showConfigAppPasswordModal,
      };
    default:
      return state;
  }
};

export default franchiseListReducer;
